export class GetCountries {
  static readonly type = '[Shared] GetCountries';
}